import React from 'react';
import { Link } from 'react-router-dom';
import { 
  Phone, 
  Mail, 
  MapPin, 
  Clock, 
  Facebook, 
  Twitter, 
  Instagram, 
  Linkedin,
  Heart,
  Shield,
  Award
} from 'lucide-react';
import './Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  // Smooth scroll to services section
  const scrollToServices = (e) => {
    e.preventDefault();
    const servicesSection = document.getElementById('services');
    if (servicesSection) {
      servicesSection.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
  };

  const quickLinks = [
    { path: '/', label: 'Home' },
    { path: '/about', label: 'About Us' },
    { path: '/services', label: 'Services' },
    { path: '/gallery', label: 'Gallery' },
    { path: '/contact', label: 'Contact' }
  ];

  const services = [
    'Nursing Care',
    'ICU at Home',
    'Elderly Care',
    'Cancer Care',
    'Mother Care',
    'Medical Equipment'
  ];

  const socialLinks = [
    { icon: Facebook, href: 'https://www.facebook.com/share/1A83QqL3yZ/', label: 'Facebook' },
    { icon: Instagram, href: 'https://www.instagram.com/shyamhealthcares?igsh=M2xpYW96ajU0NDZs', label: 'Instagram' },
    { icon: Linkedin, href: 'https://www.linkedin.com/in/shyam-healthcares-b281b6386', label: 'LinkedIn' }
  ];

  return (
    <footer className="footer">
      <div className="container">
        {/* Main Footer Content */}
        <div className="footer-content">
          {/* Company Info */}
          <div className="footer-section company-info">
            <div className="footer-logo">
              <img 
                src="/images/logo.png" 
                alt="Shyam Healthcares" 
                className="logo-image"
                width="150"
                height="50"
                loading="lazy"
              />
            </div>
            <p className="company-description">
              Providing compassionate and professional healthcare services 
              in the comfort of your home. Your health and well-being are 
              our top priorities.
            </p>
            <div className="footer-stats">
              <div className="stat-item">
                <Heart size={20} />
                <span>5000+ Happy Patients</span>
              </div>
              <div className="stat-item">
                <Shield size={20} />
                <span>15+ Years Experience</span>
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div className="footer-section">
            <h4 className="footer-title">Quick Links</h4>
            <ul className="footer-links">
              {quickLinks.map((link, index) => (
                <li key={index}>
                  <Link to={link.path}>{link.label}</Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div className="footer-section">
            <h4 className="footer-title">Our Services</h4>
            <ul className="footer-links">
              {services.map((service, index) => (
                <li key={index}>
                  <a href="#services" onClick={scrollToServices}>{service}</a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div className="footer-section contact-info">
            <h4 className="footer-title">Contact Info</h4>
            <div className="contact-items">
              <div className="contact-item">
                <Phone size={18} />
                <div>
                  <p>+91 8829988116</p>
                </div>
              </div>
              <div className="contact-item">
                <Mail size={18} />
                <div>
                  <p>shyamhealthcares@gmail.com</p>
                </div>
              </div>
              <div className="contact-item">
                <MapPin size={18} />
                <div>
                  <p>P.Lt 2, Triveni Nagar ll, Niwaru Rd, Jhotwara</p>
                  <p>Jaipur, India - 302012</p>
                </div>
              </div>
              <div className="contact-item">
                <Clock size={18} />
                <div>
                  <p></p>
                  <p>Mon-Sun: 8:00 AM - 8:00 PM</p>
                </div>
              </div>
            </div>
          </div>
        </div>

         {/* Developer Credit - Centered Below */}
         <div className="developer-credit-container">
            <div className="footer-legal developer-credit">
              <p>
                Designed & developed by 
                <a href="https://www.sandeepwebsolutions.com" target="_blank" rel="noopener noreferrer" className="developer-link">
                  www.sandeepwebsolutions.com
                </a>
                <span className="credit-tagline">• Premium Web Solutions</span>
              </p>
            </div>
          </div>

        {/* Footer Bottom */}
        <div className="footer-bottom">
        <div className="footer-bottom-content">
            <div className="copyright">
              <p>&copy; {currentYear} Shyam Healthcares. All rights reserved.</p>
            </div>
            
            <div className="footer-social">
              {socialLinks.map((social, index) => (
                <a
                  key={index}
                  href={social.href}
                  className="social-link"
                  aria-label={social.label}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <social.icon size={20} />
                </a>
              ))}
            </div>
            
            <div className="footer-legal">
              <Link to="/privacy">Privacy Policy</Link>
            </div>
          </div>

       

        
          
   
         
        </div>
      </div>
    </footer>
  );
};

export default Footer;
